// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3n0Qs","alert":"SettungsInbox_alert__37wg7"};